import { getApplicationResultBykey } from '../services';
import { INode } from '../types';

export const getTribePath = async (value: string, snapshot: string): Promise<string> => {
  const paths = await getApplicationResultBykey('global_taxon_tribe', snapshot);

  return (paths as string[]).filter((path) => path.split('/').pop() === value)[0];
};

export const getFunctionalArchitecturePath = async (value: string, snapshot: string): Promise<string> => {
  const paths = await getApplicationResultBykey('global_taxon_functional-architecture', snapshot);

  return (paths as string[]).filter((path) => path.split('/').pop() === value)[0];
};

export const computeTribesPath = (tribeFormatted: INode[]): string[] => {
  let path: string[] = [];

  tribeFormatted.forEach((item) => {
    path.push(item.fullPath ?? '');
    if (item.children && item.children.length > 0) {
      path = path.concat(computeTribesPath(item.children));
    }
  });
  return path;
};

export const formatWithFullPath = (nodes: INode[]): void => {
  if (!nodes) return;
  for (const node of nodes) {
    if (!node.fullPath) {
      node.fullPath = String(node.key);
    }
    if (!node.children) continue;
    for (const children of node.children) {
      children.fullPath = node.fullPath + '/' + children.key;
    }
    formatWithFullPath(node.children);
  }
  return;
};

export const cleanTribeUrl = (selectedTribes: string[], tribesAvailable: string[]) => {
  return tribesAvailable.filter((value) => selectedTribes.some((selection) => value.includes(selection)));
};
